import { render, staticRenderFns } from "./BackContent.vue?vue&type=template&id=3856e726"
import script from "./BackContent.vue?vue&type=script&lang=js"
export * from "./BackContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports